import { format, subMonths } from 'date-fns'
import type { TotalUsageOverTimeResponse } from 'teacher-ui-client/utils/student-events/fetchers/total-usage-over-time'

const thisMonth = format(new Date(), 'yyyy-MM')
const lastMonth = format(subMonths(new Date(), 1), 'yyyy-MM')

export const rexTotalUsageOverTime: TotalUsageOverTimeResponse = {
  total_usage_over_time_summary: [
    { category: 'assessments', event_count: 6, student_count: 2 },
    { category: 'books', event_count: 8, student_count: 3 },
    { category: 'lessons', event_count: 4, student_count: 2 },
    { category: 'quizzes', event_count: 3, student_count: 2 },
    { category: 'spelling', event_count: 6, student_count: 4 },
  ],
  total_usage_over_time_by_month: [
    {
      category: 'assessments',
      months: [
        { month: lastMonth, count: 1 },
        { month: thisMonth, count: 2 },
      ],
    },
    {
      category: 'books',
      months: [
        { month: lastMonth, count: 1 },
        { month: thisMonth, count: 2 },
      ],
    },
    {
      category: 'lessons',
      months: [
        { month: lastMonth, count: 1 },
        { month: thisMonth, count: 2 },
      ],
    },
    {
      category: 'quizzes',
      months: [
        { month: lastMonth, count: 1 },
        { month: thisMonth, count: 2 },
      ],
    },
    {
      category: 'spelling',
      months: [
        { month: lastMonth, count: 1 },
        { month: thisMonth, count: 2 },
      ],
    },
  ],
}
